import { useMemo, useState } from "react";
import { GeoJSON, Marker, Polyline, Tooltip } from "react-leaflet";
import { icon } from "leaflet";

import { Card, Stack, Typography } from "@mui/material";

import { MAP_CONTENTS_OPACITY } from "Configs/map";
import { ISurvey } from "Types/survey";

import { useAppSelector } from "Hooks/useRedux";

import SourceIcon from "Assets/Images/Survey/source-icon.svg";
import useTraffic from "Hooks/useTraffic";

const ICON_SIZE = 22;

export default function Traffic() {
  const { name } = useAppSelector((state) => state.operation);
  const { visible } = useAppSelector((state) => state.traffic);

  const [hoveredItem, setHoveredItem] = useState<ISurvey | null>(null);

  const { data } = useTraffic();

  const markers = useMemo(() => {
    if (!data) return null;

    return data?.map((item: any, indx: number) => {
      if (!item.TTO_Data) return;
      const traffic = JSON.parse(`{${item.TTO_Data}}`);
      const sourceLat = Number(traffic.GeographicalAccident);
      const sourceLng = Number(traffic.GeographicalLength);

      const sourceIcon = icon({ iconUrl: SourceIcon, iconSize: [ICON_SIZE, ICON_SIZE] });

      const events = {
        mouseover: () => {
          setHoveredItem(item);
        },
        mouseout: () => {
          setHoveredItem(null);
        },
      };

      const isActive = name === "create-path" || name === "edit-path";

      const tooltipContent = !isActive && (
        <Tooltip direction="top" offset={[0, -20]}>
          <Card sx={{ py: 2, px: 3 }}>
            <Stack alignItems="center">
              <Stack direction="row" sx={{ width: "100%", justifyContent: "space-between" }}>
                <Typography> {traffic.DeviceName} </Typography>
                <Typography> : نام سامانه </Typography>
              </Stack>
              <Stack direction="row" sx={{ width: "100%", justifyContent: "space-between" }}>
                {" "}
                <Typography> {traffic.TTO}</Typography>
                <Typography> : تعداد</Typography>
              </Stack>
              <Stack direction="row" sx={{ width: "100%", justifyContent: "space-between" }}>
                <Typography>{traffic.MethodName}</Typography>
                <Typography> : نوع سامانه</Typography>
              </Stack>
              <Stack direction="row" sx={{ width: "100%", justifyContent: "space-between" }}>
                <Typography>{traffic?.DeviceCode}</Typography>
                <Typography> : کد سامانه</Typography>
              </Stack>
            </Stack>
          </Card>
        </Tooltip>
      );

      const opacity = isActive ? MAP_CONTENTS_OPACITY : 1;

      return (
        <>
          <Marker
            key={`source-${item.id}`}
            position={[sourceLat, sourceLng]}
            icon={sourceIcon}
            eventHandlers={events}
            opacity={opacity}
          >
            {tooltipContent}
          </Marker>
        </>
      );
    });
  }, [data, visible]);

  if (!visible) return <></>;
  return <>{markers}</>;
}
